/**
 * Нягтлан Excel: огноо/сар = Asia/Ulaanbaatar (+8).
 * API-аас ирсэн UTC ISO-г УБ өдрөөр харуулна.
 */
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const BUSINESS_TZ = "Asia/Ulaanbaatar";

export function formatInUlaanbaatar(value, fmt = "YYYY-MM-DD HH:mm:ss") {
  if (value == null || value === "") return "";
  const d = dayjs(value);
  if (!d.isValid()) return "";
  return d.tz(BUSINESS_TZ).format(fmt);
}

export function monthKeyInUlaanbaatar(value) {
  if (value == null || value === "") return "Огноогүй";
  const d = dayjs(value);
  if (!d.isValid()) return "Огноогүй";
  return d.tz(BUSINESS_TZ).format("YYYY-MM");
}
